import React, { useEffect } from 'react'
import replyLogoUrl from '../../assets/logos/reply-logo-white.svg';
import jemibLogoUrl from '../../assets/logos/jemib-logo-white.svg';
import { useInViewOnce } from '../../Utilities/Observer';
import HeroBackground from './HeroBackground';

const Hero = () => {
    const [ref, visible] = useInViewOnce();
    const animationDelay = 0.04

    const heroText1 = "STUDENT"
    const heroText2 = "TECH"
    const heroText3 = "CLASH"

    const textWhiteClass = `transition-all ease-in-out duration-500 font-display uppercase text-6xl sm:text-[clamp(5rem,13vw,20rem)] text-brand-white font-black leading-none ${
            visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`
    const textTransparentClass = `transition-all ease-in-out duration-500 font-display uppercase text-6xl sm:text-[clamp(5rem,13vw,20rem)] text-transparent [-webkit-text-stroke:2px_#F4F4F4] sm:[-webkit-text-stroke:4px_#F4F4F4] font-black leading-none ${
            visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`

  return (
    <section className='w-screen bg-brand-black px-6 md:px-8 xl:px-[8vw] py-4 py-20 pt-20'>

        <HeroBackground />

        <article>
            <div className='w-full flex justify-between'>
                <img src={replyLogoUrl} className="w-40 -translate-x-2" alt="Reply logo"/>
                <img src={jemibLogoUrl} className="w-36 -translate-x-2 md:translate-y-1 lg:translate-y-3" alt="Jemib logo"/>
            </div>            <p className='text-brand-white text-sm tracking-wide font-mono my-6'><b className='text-brand-blue'>●</b> JEMIB × REPLY  · HACKATHON 2026</p>
        </article>


        <article className='my-10 md:my-8' ref={ref}>
            <div className='flex'>
                {
                    [...heroText1].map((item, i)=>{
                        return (
                            <h1 key={i} className={textWhiteClass} style={{ transitionDelay: `${i * animationDelay}s` }}>{item}</h1>
                        )
                    })
                }
            </div>
            <div className='flex'>
                {
                    [...heroText2].map((item, i)=>{
                        return (
                            <h1 key={i} className={textTransparentClass} style={{ transitionDelay: `${(heroText1.length + i) * animationDelay}s` }}>{item}</h1>
                        )
                    })
                }
            </div>
            <div className='flex'>
                {
                    [...heroText3].map((item, i)=>{
                        return (
                            <h1 key={i} className={textWhiteClass} style={{ transitionDelay: `${(heroText1.length + heroText2.length + i) * animationDelay}s` }}>{item}</h1>
                        )
                    })
                }
            </div>
        </article>
        <article className='pb-6 relative z-10'>
            <ul className='flex flex-col lg:flex-row text-brand-white font-mono gap-4 lg:gap-8 relative z-10'>
                <li><b className='text-brand-blue'>●</b> AI ON CAMPUS</li>
                <li><b className='text-brand-blue'>●</b> November 7, 2026</li>
                <li><b className='text-brand-blue'>●</b> Teams of 2 to 4</li>
                <li><b className='text-brand-blue'>●</b> University of Milano-Bicocca</li>
            </ul>

            <div className='flex flex-col md:flex-row gap-6 md:gap-4 my-8'>
                <button className='blue-btn px-8 py-4'> 
                    <a href="#iscriviti">[ REGISTER YOUR TEAM ] </a>
                </button>
                <button className='transparent-btn px-8 py-4'> 
                    <a href="#evento">[ LEARN MORE ] </a>
                </button>
            </div>
        </article>
    </section>
  )
}

export default Hero